import { render, staticRenderFns } from "./drugsManagementTable.vue?vue&type=template&id=3ea6ea5e&scoped=true"
import script from "./drugsManagementTable.vue?vue&type=script&lang=js"
export * from "./drugsManagementTable.vue?vue&type=script&lang=js"
import style0 from "./drugsManagementTable.vue?vue&type=style&index=0&id=3ea6ea5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea6ea5e",
  null
  
)

export default component.exports